const GET_FAQ_LIST_DATA = 'GET_FAQ_LIST_DATA';
const GET_FAQ_DATA_LOADING = 'GET_FAQ_DATA_LOADING';

export const TYPES_FAQ = { GET_FAQ_LIST_DATA, GET_FAQ_DATA_LOADING };
